// extracted by mini-css-extract-plugin
export default {"container":"SideBar_container__VugdC","title":"SideBar_title__TyNnN","tags-container":"SideBar_tags-container__St0W7"};